import { PlusIcon, MinusIcon } from '@heroicons/react/24/solid';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDetail } from '../../../store/reducers/product';
import { handleGetCartDetail } from '../../../store/reducers/cart';
import { authHeaders, axiosInstance, encodeValue, sendAnalyticsCustomEvent, trackMetaPixelEvent } from '../../../utils/helper';
import { deliveryId, uniqueID } from '../../../utils/constants';
import qs from 'qs';
import { autoRegister, setUser } from '../../../store/reducers/user';
import { updateTableNumberAuto } from '../../../store/reducers/order';

const Cart = (props) => {
	const { product, small = false } = props;

	const dispatch = useDispatch();
	const user = useSelector((store) => store?.user);
	const { cart } = useSelector((store) => store?.cart);
	const { details: outlet } = useSelector((store) => store?.outlet);
	const company = useSelector((store) => store?.company);
	const device = useSelector((store) => store?.device);
	const { selectedOrderType, tableNumber } = useSelector((store) => store?.order);
	const type = selectedOrderType?.av_name?.toLowerCase();


  // combo product
  const currentCartItems = cart?.item?.filter((item) => item.productID === product?.product_id) || [];

  // simple product
  const currentCartItem = cart?.item?.find((item) => item.productID === product?.product_id) || null;

  // all quantity
  const currentCartQuantity = currentCartItems.reduce((total, item) => total + Number(item.itemQuantity || 0), 0);

	const isInactive = !product?.product_status || product?.product_status === 'I';

	const handleGetCart = async () => {
		if (!user?.customerID || !user?.companyID) return;
		dispatch(
			handleGetCartDetail({
				customerID: encodeValue(user?.customerID),
				companyID: encodeValue(user?.companyID),
				storeID: encodeValue(outlet?.storeID),
				availabilityID: selectedOrderType?.av_id
			}),
		);
	};

	const handleCart = async (data) => {
		try {
			let customerID = user?.customerID;
			let companyID = user?.companyID || company?.companyID;
			if (!customerID && company?.companyID) {
				const result = await dispatch(
					autoRegister({
						companyId: Number(company?.companyID),
						deviceId: device?.device_id,
					})
				).unwrap();

				customerID = result?.customerId;
				companyID = result?.customerCompanyId;
				//update table number
				if (type === 'dine in') {
					await dispatch(updateTableNumberAuto({
						customerID: customerID,
						tableNumber: tableNumber?.id
					}));
				}
			};

			let postData = {
				unquieid: uniqueID,
				availabilityID: selectedOrderType?.av_id || deliveryId,
				availabilityName: selectedOrderType?.av_name || 'Delivery',
				shopID: encodeValue(outlet?.storeID),
				customerID: encodeValue(customerID),
				companyID: encodeValue(companyID),
			};
			if (data?.productType === 'Simple') {
				postData = {
					...postData,
					...data,
				};
			} else {
				postData = {
					...postData,
					...data,
					comboset: JSON.stringify(data?.comboset),
				};
			}

			sendAnalyticsCustomEvent('add_to_cart', {
				customer_id: user?.customerID,
				value: postData?.productTotalPrice || postData?.price || 0,
				merchants_id: outlet?.storeID,
				items: postData,
			});
			trackMetaPixelEvent('add_to_cart', {
				customer_id: user?.customerID,
				value: postData?.productTotalPrice || postData?.price || 0,
				merchants_id: outlet?.storeID,
				items: postData,
			});

			const url = `cart/${data?.type === 'add' ? 'createCart' : 'updateCartItem'}`;
			const res = await axiosInstance.post(url, qs.stringify(postData), authHeaders());
			if (res?.data?.status === 'ok') {
				await Promise.resolve(
					dispatch(
						setUser({
							customerID,
							companyID
						})
					)
				);
				await handleGetCart();
			}
		} catch (error) {
			console.log('error: ', error);
		}
	};

	const handleGetDetail = async (product) => {
		if (!product?.product_id) return;

    dispatch(setDetail(product));
	};

	const handleClick = async (type) => {
		console.log('handleClick');
		if (isInactive) return;

		if (product?.product_type === '2' && Number(currentCartQuantity) > 0) {
			return handleGetDetail(product);
		}
		// // 1 = simple product
		// // 2 = combo product
		let prevTotal = Number(currentCartQuantity);
		if (type === 'plus') {
			prevTotal = prevTotal + 1;
		} else {
			prevTotal = prevTotal !== 0 ? prevTotal - 1 : 0;
		}

		const dataCart = {
			productID: product?.product_id,
			quantity: prevTotal,
			type: !cart ? 'add' : 'update',
			productType: product?.product_type === '1' ? 'Simple' : 'Combo',
			itemID: currentCartItem?.itemID || null,
			specialNotes: currentCartItem?.itemNotes ?? '',
			productPrimaryID: currentCartItem?.product_primary_id ?? null,
		};

		handleCart(dataCart);
	};

	return (
		<div className='absolute bottom-0 right-0 m-2 z-10'>
			{Number(currentCartQuantity || 0) ? (
				<div className={`bg-white p-1 rounded-md flex items-center border-solid border-1 border-[var(--byzantium)] ${isInactive ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
					<MinusIcon
						className={`${small ? 'h-3 w-3' : 'h-5 w-5'} ${isInactive ? 'text-gray-400' : 'text-[var(--byzantium)]'}`}
						onClick={(event) => {
							if (isInactive) return;
							event.stopPropagation();
							handleClick('minus');
						}}
					/>
					<input type='text' className={`!bg-white !m-0 !p-0 ${small ? '!h-3 !w-5' : '!h-5 !w-8'} text-center text-black opacity-100 ${small ? 'font-normal !text-xxs' : 'font-semibold text-xs'}`} value={Number(currentCartQuantity || 0)} disabled />
					<PlusIcon
						className={`${small ? 'h-3 w-3' : 'h-5 w-5'} ${isInactive ? 'text-gray-400' : 'text-[var(--byzantium)]'}`}
						onClick={(event) => {
							if (isInactive) return;
							event.stopPropagation();
							handleClick('plus');
						}}
					/>
				</div>
			) : (
				<div className={`bg-white p-1 rounded-md border-1 border-solid border-[var(--byzantium)] ${isInactive ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
					<PlusIcon className={`${small ? 'h-3 w-3' : 'h-5 w-5'} ${isInactive ? 'text-gray-400' : 'text-[var(--byzantium)]'}`} />
				</div>
			)}
		</div>
	);
};

export default Cart;
